import { render, staticRenderFns } from "./userAdd.vue?vue&type=template&id=20ee8bf8&scoped=true"
import script from "./userAdd.vue?vue&type=script&lang=js"
export * from "./userAdd.vue?vue&type=script&lang=js"
import style1 from "./userAdd.vue?vue&type=style&index=1&id=20ee8bf8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee8bf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ee8bf8')) {
      api.createRecord('20ee8bf8', component.options)
    } else {
      api.reload('20ee8bf8', component.options)
    }
    module.hot.accept("./userAdd.vue?vue&type=template&id=20ee8bf8&scoped=true", function () {
      api.rerender('20ee8bf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/userAdd.vue"
export default component.exports